import { useAnalyticsPageTracking } from '../../hooks/useAnalyticsPageTracking';

const AnalyticsTracker = () => {
    useAnalyticsPageTracking();
    return null;
};

export default AnalyticsTracker;
